<h3>Add Customer Address | Customer Name {{this.customerService.selectedCustomer.customername}} <span class="highlight">(Click on an address to edit)</span></h3><button class="cancel btn btn-warning" (click)="goBack()">Return to Customers</button>
<button  class="btn btn-default" (click)="onAdd(this.customerService.selectedCustomer)">Add Address</button>
<hr>
<div class="container divtable">
    <div class="divtablebody">
        <div class=" divrow">
                <div class="coltitle  col-md-2 appcol addresscol">Serial</div>
            <div class="coltitle  col-md-2 appcol addresscol">Address</div> 
            <div class="coltitle  col-md-2 appcol zipcol">Zip</div>
            <div class="coltitle  col-md-2 appcol btncol">&nbsp;</div>
             
        </div>
        
        @for (customeraddress of customeraddresses; track customeraddress.id) {
        <div class=" divrow" (click)="onEdit(customeraddress)">

            <div class="col-md-2 appcol serialscol appcell">{{customeraddress.addressserial}}</div>
                
            <div class="col-md-2 appcol addresscol appcell">{{customeraddress.addressline1 + " " + customeraddress.addressline2}}</div>
            
            <div class="col-md-2 appcol zipcol appcell">{{customeraddress.addresszip}}</div>

             <div class="col-md-2 appcol btncol">
              <button class="delete btn-xs btn-danger" (click)="deleteCustomeraddress(customeraddress); $event.stopPropagation()">Delete</button>    
            </div>
        </div>
        }
     </div>
    </div>
